import { Model } from './model';
import { ProductLineMetadata } from './product-line.metadata';

export class ProductLine {
    public ProductLineId: number;
    public ProductLineCode: string;
    public ProductLineDescription: string;
    public Favorite: boolean;
    public Models: Model[];
    public PlantId: number;
    public Metadata: ProductLineMetadata;
    public Selected: boolean;

    // used in BAQ admin page
    public BAQAvailable: boolean;

    constructor() {
        this.Models = new Array<Model>();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/product-line.ts